var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cruise-rederij-usps width100 nofloat nopadding"},_vm._l((_vm.items),function(item,index){return _c('span',{key:'USPSItem' + index},[_c('span',{staticClass:"midgroen marginright5"},[_vm._v("✔")]),_vm._v(" "+_vm._s(item)),_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }